import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    complete: {},
};
export const tasksSlice = createSlice({
    name: "tasks",
    initialState,
    reducers: {
        markComplete: (state, action) => {
            state.complete[action.payload] = true;
        },
        markIncomplete: (state, action) => {
            state.complete[action.payload] = false;
        },
    },
});
export const { markComplete, markIncomplete } = tasksSlice.actions;
export const selectIsComplete = (state, taskId) => state.tasks.complete[taskId] ?? false;
export default tasksSlice.reducer;
